var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"fill-height",attrs:{"fluid":""}},[_c('v-row',{attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"12","xl":"6","md":"12","sm":"12","xs":"12"}},[_c('Map')],1),_c('v-col',{attrs:{"cols":"12"}},[_c('Info')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }